<h1>
	User Profile
</h1>

<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<strong>Username:</strong> {{user.USER_ID}}
	</div>
</div>
<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<strong>Name:</strong> {{user.PERSON?.FIRST_NAME}} {{user.PERSON?.MIDDLE_INITIAL}}
		{{user.PERSON?.LAST_NAME}}
		{{user.PERSON?.SUFFIX}}
	</div>
</div>
<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<strong>Email Address:</strong> {{user.EMAIL_ADDRESS}}
	</div>
</div>

<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<button mat-raised-button routerLink="/account/user-profile/edit" class="margin-right-xs">Edit Profile</button>
		<button mat-raised-button routerLink="/account/user-profile/change-password">Change Password</button>
	</div>

</div>

<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Contact Information</mat-card-title></mat-card-header>
			<mat-card-content>
				<view-party-contact-mechanism *ngIf="user.PERSON?.PARTy?.ID" [partyId]="user.PERSON?.PARTy?.ID!"
					[enabledTypes]="['postalAddresses', 'phoneNumbers']" [filterAddressTypes]="['Work Address']"
					[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
					[removeAddressTypes]="['Birthplace Address']">
				</view-party-contact-mechanism>
			</mat-card-content>
		</mat-card>
	</div>

</div>

<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Region/Organization</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div>
					<Strong>Region:</Strong>
					{{user.REGION?.NAME}} ({{user.REGION?.CODE}})
				</div>
				<div>
					<Strong>Works For:</Strong>
					{{user.WORKS_FOR?.NAME}}
				</div>
				<div>
					<Strong>School Districts(s): </Strong>
					<span *ngIf="user.SCHOOL_DISTRICTS?.length! === 0">---</span>
					<mat-chip-listbox *ngIf="user.SCHOOL_DISTRICTS ? user.SCHOOL_DISTRICTS?.length! > 0 : false">
						<mat-chip-option *ngFor="let sd of user.SCHOOL_DISTRICTS">{{sd.DISTRICTS}}</mat-chip-option>
					</mat-chip-listbox>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

</div>

<div class="row margin-vertical-xs">
	<div class="col-lg-12">
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>System Role(s)</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div *ngFor="let role of user.USER_ROLES">
					{{role.ROLE?.NAME}}
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>